/* SIGILMARKED JEANS drop clock.
   One script for every [data-sj-drop] root on the page: the homepage hero, the homepage rail
   and the jeans collection page all carry one. It counts down to data-target, and at zero it
   swaps the pre stack for the live stack, the link targets with it, and writes the drop time
   in UK time, labelled (UK), the same for every visitor. The pattern is the one in sections/feral-jersey-drop.liquid.

   Three states, not two:
     pre   before data-target. The countdown runs.
     live  after data-target AND the new products are visible to the storefront.
     due   after data-target but data-products="draft": the products are not active yet
           (or this HTML was cached before they were). Nothing may link to a product page
           that does not exist, so the pre stack stays, without a countdown stuck on zero,
           and anything carrying data-due says "dropping now" instead of a date that has passed.

   Due is meant to be short, and the page ends it itself: while due it asks the store for its own
   section again (the Section Rendering API: this URL plus ?sections=<id>, one rendered section as
   JSON) and reloads the moment that comes back with data-products="live". So the person waiting on
   the page at 16:00 is not the one who has to refresh, and a page rendered before the products
   were activated, or served from a cache, still ends up live. A reload is a clean start of
   everything; it waits while somebody is typing in the list box, and it will not loop on a
   stale cache (three reloads in ten minutes and it stops, the next refresh is the visitor's).

   Due should not happen at all when the products go active early, and they do: Andie activates a
   drop about ten minutes before its time (2026-09-30, the skort: "I always put it 10 minutes live
   before the actual release time"). A page opened before that still carries data-products="draft",
   so at zero it showed "dropping now" and reloaded. So in the last quarter of an hour a page that
   still says draft asks the store for its section too, and when the answer is live it sets its own
   data-products: zero then goes straight from the countdown to live, in place, with no reload. It
   only ever learns draft -> live. A stale cached render must not unteach what a fresher page knows. */
(function () {
  'use strict';
  if (window.__feralSjDrop) return; // two sections on one page both load this file
  window.__feralSjDrop = true;

  var MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sept', 'oct', 'nov', 'dec'];
  var applied = typeof WeakMap === 'function' ? new WeakMap() : null;
  var kept = applied ? new WeakMap() : null;
  var editor =!!(window.Shopify && window.Shopify.designMode); // the theme editor swaps markup itself; never reload under it

  // ── the end of due: ask, then reload ──────────────────────────────────────────────────────────────
  var ask = { timer: null, since: 0, fails: 0, done: false };
  var FLIP_KEY = 'feral-sj-flip';

  function sectionId(root) {
    var w = root.closest ? root.closest('[id^="shopify-section-"]') : null;
    return w ? w.id.slice('shopify-section-'.length) : root.getAttribute('data-section-id');
  }
  function sectionUrl(id) {
    var u = new URL(location.href);
    u.searchParams['delete']('preview_theme_id'); // the preview cookie is already set; the parameter would redirect
    u.searchParams.set('sections', id);
    u.hash = '';
    return u.pathname + u.search;
  }
  // Somebody mid-way through the list box: never take the page away from under them.
  function busy() {
    var a = document.activeElement;
    if (a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA') && a.value) return true;
    var open = document.querySelector('[data-jcp-list].is-open');
    if (open) {
      var f = open.querySelector('input');
      if ((f && f.value) || open.querySelector('[aria-disabled="true"]')) return true;
    }
    return false;
  }
  function flips() {
    try { return JSON.parse(sessionStorage.getItem(FLIP_KEY) || '[]').filter(function (t) { return Date.now() - t < 600000; }); } catch (e) { return []; }
  }
  function reload() {
    if (busy()) { setTimeout(reload, 2000); return; }
    var past = flips();
    if (past.length >= 3) { ask.done = true; return; } // a cache still serving the old render: stop, rather than flicker
    past.push(Date.now());
    try { sessionStorage.setItem(FLIP_KEY, JSON.stringify(past)); } catch (e) { /* private mode */ }
    location.reload();
  }
  function wait() {
    var t = Date.now() - ask.since;
    var base = t < 900000 ? 30000 : t < 7200000 ? 60000 : 300000; // every 30 s for a quarter of an hour, then a minute, then five
    if (ask.fails >= 5) base = Math.max(base, 120000);
    return base + Math.random() * base * 0.5;
  }
  function check(root) {
    ask.timer = null;
    if (ask.done || editor) return;
    if (root.getAttribute('data-products') === 'live') { ask.done = true; return; } // a look before zero landed late; already live in place
    if (Date.now() - ask.since > 43200000) { ask.done = true; return; } // twelve hours of due: the visitor's next refresh is enough
    if (document.hidden) { ask.timer = setTimeout(function () { check(root); }, 15000); return; } // a background tab does not poll
    var id = sectionId(root);
    if (!id || typeof fetch !== 'function' || typeof URL !== 'function') { ask.done = true; return; }
    fetch(sectionUrl(id), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('' + r.status); return r.json(); })
      .then(function (j) {
        var html = j && j[id];
        if (typeof html !== 'string') throw new Error('no section');
        ask.fails = 0;
        if (/\sdata-products="live"/.test(html)) { ask.done = true; reload(); return; }
        ask.timer = setTimeout(function () { check(root); }, wait());
      })
      .catch(function () { ask.fails++; ask.timer = setTimeout(function () { check(root); }, wait()); });
  }
  function startAsking(root) {
    if (ask.since || ask.done || editor) return;
    ask.since = Date.now();
    var last = flips();
    var first = last.length ? 20000 + Math.random() * 10000 : 2000 + Math.random() * 5000; // straight after a flip-reload, give the cache a moment
    ask.timer = setTimeout(function () { check(root); }, first);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && ask.timer && !ask.done) { clearTimeout(ask.timer); ask.timer = setTimeout(function () { check(root); }, 500); }
    });
  }

  // ── before zero: learn that the products went active early ────────────────────────────────────────
  var PEEK = 900000; // the last fifteen minutes
  var peeks = {}; // by section id
  function peekWait() { return 30000 + Math.random() * 15000; }
  function peek(root, id, target) {
    var p = peeks[id];
    p.timer = null;
    if (p.done || editor) return;
    if (Date.now() >= target) { p.done = true; return; } // zero has come; due takes it from here
    if (document.hidden) { p.timer = setTimeout(function () { peek(root, id, target); }, 15000); return; } // a background tab does not poll
    fetch(sectionUrl(id), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('' + r.status); return r.json(); })
      .then(function (j) {
        var html = j && j[id];
        if (typeof html !== 'string') throw new Error('no section');
        if (/\sdata-products="live"/.test(html)) { p.done = true; root.setAttribute('data-products', 'live'); return; }
        p.timer = setTimeout(function () { peek(root, id, target); }, peekWait());
      })
      .catch(function () { p.timer = setTimeout(function () { peek(root, id, target); }, peekWait()); });
  }
  function startPeeking(root, target) {
    if (editor || typeof fetch !== 'function' || typeof URL !== 'function') return;
    var id = sectionId(root);
    if (!id || peeks[id]) return;
    var p = peeks[id] = { timer: null, done: false };
    p.timer = setTimeout(function () { peek(root, id, target); }, 1000 + Math.random() * 4000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && p.timer && !p.done) { clearTimeout(p.timer); p.timer = setTimeout(function () { peek(root, id, target); }, 500); }
    });
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  // Anton's "1" is narrower than its "8". Each digit gets its own fixed box so the row never twitches.
  function writeDigits(el, str) {
    if (el.getAttribute('data-v') === str) return;
    el.setAttribute('data-v', str);
    while (el.firstChild) el.removeChild(el.firstChild);
    for (var i = 0; i < str.length; i++) {
      var dg = document.createElement('span');
      dg.className = 'dg';
      dg.textContent = str.charAt(i);
      el.appendChild(dg);
    }
  }

  // The drop is said in UK time and says so, for everybody. It used to be the visitor's own clock with no label:
  // 16:00 in London, 17:00 in Amsterdam, and nobody could tell which one they were reading.
  // Where Intl cannot do a named zone these return null and the words the server printed stay as they are.
  var UK = (function () {
    try {
      return new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', day: 'numeric', month: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    } catch (e) { return null; }
  })();
  function ukParts(ms) {
    if (!UK || typeof UK.formatToParts !== 'function') return null;
    var out = {};
    UK.formatToParts(new Date(ms)).forEach(function (p) { out[p.type] = p.value; });
    return out.weekday && out.day && out.month && out.hour && out.minute ? out : null;
  }
  function dropDate(ms) {
    var p = ukParts(ms);
    return p ? p.weekday.toLowerCase().slice(0, 3) + ' ' + parseInt(p.day, 10) + ' ' + MONTHS[parseInt(p.month, 10) - 1] : null;
  }
  function dropLine(ms) {
    var p = ukParts(ms);
    return p ? dropDate(ms) + ' · ' + p.hour + ':' + p.minute + ' (UK)' : null;
  }

  function render(root) {
    var target = Date.parse(root.getAttribute('data-target') || '');
    var ms = target - Date.now();
    var state = isNaN(target) ? 'due' : ms > 0 ? 'pre' : (root.getAttribute('data-products') === 'draft' ? 'due' : 'live');

    if (state === 'pre') {
      var s = Math.floor(ms / 1000);
      var parts = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
      root.querySelectorAll('[data-cd]').forEach(function (cell) {
        writeDigits(cell, pad(parts[cell.getAttribute('data-cd')]));
      });
    }

    var was = applied ? applied.get(root) : root.__sjState;
    if (was !== state) {
      if (applied) applied.set(root, state); else root.__sjState = state;
      var live = state === 'live';
      root.setAttribute('data-state', state);
      root.classList.toggle('is-live', live);
      root.querySelectorAll('[data-when]').forEach(function (el) {
        var show = el.getAttribute('data-when') === 'live' ? live : !live;
        if (show && el.getAttribute('role') === 'timer') show = state === 'pre';
        el.hidden = !show;
      });
      root.querySelectorAll('[data-live-href]').forEach(function (a) {
        if (!a.getAttribute('data-pre-href')) a.setAttribute('data-pre-href', a.getAttribute('href'));
        a.setAttribute('href', live ? a.getAttribute('data-live-href') : a.getAttribute('data-pre-href'));
      });
      // "drops thu 24 sept · 16:00 (UK)" is a date that has passed once due: say "dropping now" where the markup offers it
      if (kept) root.querySelectorAll('[data-due]').forEach(function (el) {
        if (state === 'due') {
          if (kept.has(el)) return;
          var frag = document.createDocumentFragment();
          while (el.firstChild) frag.appendChild(el.firstChild);
          kept.set(el, frag); // the server's own words, put back whole if the state ever goes back
          el.textContent = el.getAttribute('data-due');
        } else if (kept.has(el)) { el.textContent = ''; el.appendChild(kept.get(el)); kept['delete'](el); }
      });
    }
    if (state === 'due') startAsking(root);
    if (state === 'pre' && ms <= PEEK && root.getAttribute('data-products') === 'draft') startPeeking(root, target);

    if (isNaN(target) || state === 'due') return;
    root.querySelectorAll('[data-drop-time]').forEach(function (el) {
      var line = dropLine(target);
      if (line && el.textContent !== line) el.textContent = line;
    });
    root.querySelectorAll('[data-drop-date]').forEach(function (el) {
      var line = dropDate(target);
      if (line && el.textContent !== line) el.textContent = line;
    });
  }

  function tick() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sj-drop]'), render);
  }

  tick();
  setInterval(tick, 1000);
  // the theme editor swaps a section's markup in place; the next tick picks the new root up on its own
})();
